import { Form } from 'antd';

import { CustomSelect } from 'components';

import { AggregatedProductIdentity } from 'codegen';

const { useFormInstance, Item } = Form;

export const TypeSelect = () => {
  const form = useFormInstance();

  return (
    <Item
      name='type'
      className='mb-0'
      rules={[{
        message: 'Required',
        required: true,
      }]}
    >
      <CustomSelect
        name='type'
        options={Object.values(AggregatedProductIdentity.type).map((type) => ({ label: type, value: type }))}
        allowClear={false}
        onChange={(value) => {
          form.setFieldsValue({ type: value });

          const values = form.getFieldsValue();
          const someNewFieldEmpty = Object.keys(values).some((key) => !values[key]);

          if (someNewFieldEmpty && value === AggregatedProductIdentity.type.NAME) {
            form.resetFields(['fullMatchThreshold', 'partialMatchThreshold']);
            form.setFieldValue('partialMatchThreshold', 0.77);
            form.setFieldValue('fullMatchThreshold', 0.9);
            form.setFieldValue('hasAutoCalculatedThresholds', false);
          }

          if (someNewFieldEmpty && value === AggregatedProductIdentity.type.SKU) {
            form.resetFields(['fullMatchThreshold', 'partialMatchThreshold']);
            form.setFieldValue('partialMatchThreshold', 0.8);
            form.setFieldValue('fullMatchThreshold', 1);
            form.setFieldValue('hasAutoCalculatedThresholds', false);
          }

          if (someNewFieldEmpty && value === AggregatedProductIdentity.type.AI) {
            form.resetFields(['fullMatchThreshold', 'partialMatchThreshold']);
            form.setFieldValue('partialMatchThreshold', undefined);
            form.setFieldValue('fullMatchThreshold', undefined);
            form.setFieldValue('hasAutoCalculatedThresholds', true);
          }
        }}
      />
    </Item>
  );
};
